import type { ReactNode } from 'react'
import {
  Activity,
  Bot,
  Database,
  Key,
  LayoutDashboard,
  LayoutTemplate,
  Printer,
  HelpCircle,
} from 'lucide-react'

const ICON_MAP: Record<string, ReactNode> = {
  // keyed by Lucide icon name (used by WorkspacePage via module.icon)
  Activity:        <Activity />,
  Bot:             <Bot />,
  Database:        <Database />,
  Key:             <Key />,
  LayoutDashboard: <LayoutDashboard />,
  LayoutTemplate:  <LayoutTemplate />,
  Printer:         <Printer />,
  // keyed by module slug (used by AppLayout sidebar via inst.slug fallback)
  dashboard:  <Activity />,
  agents:     <Bot />,
  resources:  <Database />,
  tokens:     <Key />,
  templates:  <LayoutTemplate />,
  printers:   <Printer />,
}

/** Resolves a Lucide icon name or module slug to a ReactNode. */
export function resolveIcon(name: string): ReactNode {
  return ICON_MAP[name] ?? <HelpCircle />
}
